export default __webpack_public_path__ + "static/media/Mahabalipuram_Shore temple.2129e9a4.JPG";